module.exports = __webpack_public_path__ + "201811/img/top_22.4743e2e3.png";